import FormattedExistSubList from '../interfaces/FormattedExistSubList';

export default function formateExistSubList (existSubscription): FormattedExistSubList {

  let activeSub = [];
  let closedSub = [];

  if (existSubscription && existSubscription.length) {
    closedSub =
      existSubscription
        .sort(sortExistSubList)
        .filter(subscription => new Date(subscription.date_finish) < new Date());

    activeSub =
      existSubscription
        .sort(sortExistSubList)
        .filter(subscription => new Date(subscription.date_finish) > new Date());

  }

  return {
    activeSub,
    closedSub,
  };
}

function sortExistSubList (a, b): number {
  return a.id > b.id ? -1 : a.id < b.id ? 1 : 0;
}
